import React from 'react';
export function Hero() {
  return <div className="relative w-full pt-24 h-[50vh] md:h-[60vh]" data-id="element-273">
      <div className="absolute inset-0 top-24" data-id="element-274">
        <img src="https://images.squarespace-cdn.com/content/v1/5d69727e387da800014a7af2/1572404825959-NQKPIG67KKSP57X1PLIU/kamila-maciejewska-b2bXKspL5MY-unsplash.jpg?format=2500w" alt="Hero Background" className="w-full h-full object-cover" data-id="element-275" />
        <div className="absolute inset-0 bg-black/30" data-id="element-276" />
      </div>
      <div className="relative z-10 h-full flex flex-col items-center justify-center text-white px-4" data-id="element-277">
        <h1 className="font-heading font-light text-5xl md:text-6xl text-center max-w-4xl leading-tight mb-6 tracking-wide" data-id="element-278">
          We Fight the Signs of Aging
        </h1>
        <p className="font-body text-2xl tracking-wider uppercase text-center" data-id="element-279">
          Med Spa & Traveling Concierge
        </p>
      </div>
    </div>;
}